import React, { useState } from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import {
  makeStyles,
  Typography,
  Button,
} from '@material-ui/core';
import { twoOrMoreDecimals } from 'utils/helpers';
import api from 'utils/api';
import { FormField2 } from 'components';


const useStyles = makeStyles({
  root: {},
  bold: {
    fontWeight: 'bold',
  },
  textCenter: {
    textAlign: 'center',
  },
  textRight: {
    textAlign: 'right',
  },
  table: {
    borderCollapse: 'collapse',
    width: '100%',
    fontSize: 12,
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',

    '& thead tr': {
      '& td, th': {
        border: '1px solid #ddd',
        padding: 8,
      },
    },

    '& tbody tr': {
      '&:not(.no-hover):hover': {
        backgroundColor: '#d9d9d9',
        cursor: 'pointer',
      },

      '& td, th': {
        border: '1px solid #ddd',
        padding: 8,
      },
    },

    '& input[type="number"], input[type="text"]': {
      textAlign: 'right',
      border: '1px solid #316ac5',
      borderRadius: '4px',
      margin: '2px 0px',

      '&[disabled]': {
        border: '1px solid #cccccc',
      }
    },

    '& input[type="text"]': {
      borderColor: '#c4c4c4',
      padding: '6px 6px 7px',
      color: '#12161b',
      textAlign: 'left',
    },
  },
});

const EstimateObjectSettingsModal = ({ totals, id, onClose }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [numbersAfterDecimal, setNumbersAfterDecimal] = useState(totals?.numbersAfterDecimal);

  const handleNumbersAfterDecimalUpdate = async () => {
    try {
      if (totals.numbersAfterDecimal === numbersAfterDecimal) return;

      await api.put(`/estimates/${id}/`, { totals: { ...totals, numbersAfterDecimal: parseInt(numbersAfterDecimal)}});
      onClose(true);
    } catch (err) {
      console.error(err);
    }
  }
  const options = [0, 1, 2, 3].map(number => ({ value: number.toString(), label: number.toString() }));

  return (
    <>
      <table className={classes.table}>
        <tbody>
            <tr key={totals?.numbersAfterDecimal}>
              <td style={{ width: '70%' }} >{t('Kainos ženklų skaičius po kablelio')}</td>
              <td style={{ width: '15%', padding: '2px 8px' }}>
                <FormField2
                  type="select"
                  name="value"
                  value={numbersAfterDecimal.toString()}
                  options={options}
                  onChange={({ value }) => setNumbersAfterDecimal(value)}
                  naked
                />
              </td>
              <td style={{ width: '15%', padding: '2px 8px' }}>
                <Button 
                  variant="contained" 
                  color="primary" 
                  onClick={handleNumbersAfterDecimalUpdate}
                  disabled={totals?.numbersAfterDecimal == numbersAfterDecimal}
                >
                  {t('Perskaičiuoti')}
                </Button>
              </td>
            </tr>
        </tbody>
      </table>
    </>
  )
}

export default EstimateObjectSettingsModal;